import { JobType } from '@api*';
import {
  faCheck,
  faHouseLaptop,
  faTimes,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group } from '@mantine/core';

type ConfirmedPropsType = {
  jobType: JobType | null;
};

export const Confirmed: React.FC<ConfirmedPropsType> = ({ jobType }) => {
  const confirmedIcon = jobType?.isConfirmed ? faCheck : faTimes;
  const showRemoteIcon = jobType?.isRemote && jobType?.isConfirmed;
  const color = jobType?.isConfirmed
    ? 'var(--mantine-color-gray-8)'
    : 'var(--mantine-color-text-4)';

  return (
    <Group gap={0}>
      <FontAwesomeIcon icon={confirmedIcon} color={color} />
      {showRemoteIcon && <FontAwesomeIcon icon={faHouseLaptop} color={color} />}
    </Group>
  );
};
